import React from "react";

const PrintButton = ({ text, link }) => {

  //Function
  const redirect = () => {
    window.location.href = link;
  };

  return (
    <div className="print">
      <button onClick={redirect}>
        {text}
      </button>
    </div>
  );
};

export default PrintButton;
